<template>
  <v-container fluid class="page--leaderboards">
    <v-row class="page-content">
      <v-col cols="12" class="mt-4 d-flex">
        <div class="d-flex flex-grow-1">
          <div class="primary700 px-2 py-3 d-flex align-center mr-4">
            <fai
              :icon="['fad', 'users-crown']"
              class="text-h3 primary100--text mx-3"
              fixed-width
            />
          </div>

          <div class="bg-ui-panel px-4 py-3 flex-grow-1">
            <h2 v-t="'page.leaderboards.title'" class="text-h6 font-weight-bold mb-1" />

            <i18n tag="p" class="mb-0 text-body-2 lh-1-2" path="page.leaderboards.subtitle">
              <span v-t="daysToWord[days]" />
            </i18n>

            <p v-t="'page.leaderboards.update'" class="text-caption mb-0 text--secondary" />
          </div>
        </div>

        <div class="ml-4 countdown-ctn green700 green100--text px-6 d-flex align-center">
          <div>
            <h4 class="text-uppercase text-caption font-weight-bold">
              Resets in
            </h4>
            <span
              v-if="resetsIn > 48 * 60 * 60e3"
              class="text-h5 font-weight-bold"
              v-text="relativeReset"
            />
            <Countdown
              v-else
              class="text-h5 font-weight-bold"
              :duration="resetsIn / 1000"
              format="DD:HH:mm:ss"
            />
          </div>
        </div>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-btn-toggle
          v-model="days"
          mandatory dense tile borderless
          color="primary400"
          background-color="primary100"
        >
          <v-btn v-t="'common.today'" :value="0" :ripple="false" class="text-caption font-weight-bold px-4" />
          <v-btn v-t="'common.week'" :value="7" :ripple="false" class="text-caption font-weight-bold px-4" />
          <v-btn v-t="'common.month'" :value="28" :ripple="false" class="text-caption font-weight-bold px-4" />
        </v-btn-toggle>
      </v-col>

      <!-- HACK absolutely disgusting code -->
      <v-col v-if="leaderboard" cols="12">
        <v-row>
          <v-col v-for="(rank, i) in RANKS" :key="i" cols="4" :order="rank.order">
            <div :class="`rank--${i + 1}`" class="px-3 py-6 d-flex align-center justify-center bg-ui-panel ">
              <UserAvatar
                :user="leaderboard[i] || {}"
                :size="58"
                class="user-avatar mb-4 mr-6 link"
                @click.native="leaderboard[i] && $userMenu.open($event, leaderboard[i])"
              />
              <div class="text-truncate">
                <i18n
                  tag="h6" class="text-caption lh-1-2 font-weight-bold primary500--text text-uppercase"
                  path="page.leaderboards.rank"
                >
                  <span v-text="i + 1" />
                </i18n>
                <Username
                  v-if="leaderboard[i]"
                  :user="leaderboard[i]"
                  class="text-body-1 grey100--text mb-1 text-truncate link"
                  @click.native="leaderboard[i] && $userMenu.open($event, leaderboard[i])"
                />
                <span v-else v-t="'page.leaderboards.claim'" class="text--disabled" />
                <scrap
                  v-if="leaderboard[i]"
                  :amount="leaderboard[i].totalWon"
                  class="text-body-2 grey100--text"
                />
              </div>
            </div>
            <div v-if="prizes[i]" class="mt-2 green800 green200--text px-3 py-2 d-flex align-center">
              <span class="text-uppercase font-weight-bold text-caption">Prize</span>
              <v-spacer />
              <scrap :amount="prizes[i]" class="text-body-2" />
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="leaderboard" cols="12">
        <div
          v-for="(user, i) in withoutTopThree" :key="user.steamid"
          class="mb-4 d-flex"
        >
          <div
            class="flex-grow-1 bg-ui-panel px-3 py-2 d-flex align-center bg-ui-panel"
            :class="{'is-me': session && session.steamid === user.steamid}"
            @click="$userMenu.open($event, user)"
          >
            <span class="mr-3 primary500--text font-weight-bold">#{{ 4 + i }}</span>
            <UserAvatar :user="user" :size="32" class="mr-3" />
            <Username :user="user" class="text-body-2 text-truncate" />
            <v-spacer />
            <scrap :amount="user.totalWon" class="text-body-2 grey100--text" />
          </div>
          <div v-if="prizes[3 + i]" class="ml-2 listing-prize green800 green200--text px-3 py-2 d-flex align-center justify-center">
            <span class="text-uppercase font-weight-bold text-caption mr-2">Prize</span>
            <scrap :amount="prizes[3 + i]" class="text-body-2" />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

const RANKS = [
  {
    order: 2,
    color: 'gold',
  },
  {
    order: 1,
    color: 'gold',
  },
  {
    order: 3,
    color: 'gold',
  },
]

export default {
  metaInfo() {
    return {
      title: this.$t('page.leaderboards.title'),
    }
  },
  data() {
    return {
      days: 0,
      leaderboard: [],
    }
  },
  computed: {
    ...mapGetters({
      session: 'user/session',
      conga: 'conga/conga',
    }),
    RANKS() {
      return RANKS
    },
    daysToWord() {
      return {
        0: 'common.today',
        7: 'page.leaderboards.this_week',
        28: 'page.leaderboards.this_month',
      }
    },
    withoutTopThree() {
      return this.leaderboard.slice(3)
    },
    prizes() {
      const config = this.conga.leaderboardRewards
      const { days } = this

      const DAYS = {
        0: 'day',
        7: 'week',
        28: 'month',
      }

      if (config.disabled || config[DAYS[days]]?.disabled) {
        return {}
      }

      return config[DAYS[days]]?.rankPrizes ?? {}
    },
    resetsIn() {
      const { days } = this

      switch (days) {
        case 0:
          return DateTime.utc().endOf('day').diffNow().toMillis()
        case 7:
          return DateTime.utc().endOf('week').diffNow().toMillis()
        case 28:
          return DateTime.utc().endOf('month').diffNow().toMillis()
        default:
          return 0
      }
    },
    relativeReset() {
      const { relativeTime } = this.$options.filters

      const relative = relativeTime(Date.now() + this.resetsIn)

      return relative.replace('in', '').trim()
    },
  },
  watch: {
    days(val) {
      this.getLeaderboards(val)
    },
  },
  created() {
    this.getLeaderboards()
  },
  methods: {
    async getLeaderboards(days = this.days) {
      try {
        const leaderboards = await this.$socket.request('leaderboard.get', days)
        this.leaderboard = leaderboards
      } catch (error) {
        this.$toast.error(error.message)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page--leaderboards {
  min-height: calc(100vh - var(--top));
  background: grey(900); // fallback
  background: url('../assets/img/leaderboards.jpg') no-repeat top center;
  background-size: cover;

  &::before {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(grey(800), 0.7) 50%, rgba(grey(800), 0.99) 80%);
    content: ' ';
    // pointer-events: none;
  }
}

.page-content {
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;
}

.rank {
  &--1 {
    margin-top: 0;
  }

  &--2 {
    margin-top: 24px;
  }

  &--3 {
    margin-top: 48px;
  }
}

.user-avatar {
  overflow: visible;
  transform: rotate(-5deg);

  &::before {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 100%;
    height: 100%;
    background: primary(400);
    content: ' ';
  }
}

.is-me {
  background-color: green(800) !important;
}

.countdown-ctn {
  min-width: 180px;
  transform: rotate(3deg) translateY(5px);
}

.listing-prize {
  min-width: 124px;
}
</style>
